import { CARRIERS } from '@web-platform/shared-universal-constants/src/queryParams';
import { booleanKeyValuesParamParser } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/paramParsers';
import { parseParams } from '@web-platform/shared-universal-utils-frontend/src/helpers/queryParams/parseParams';
import { GLOBAL } from 'saddlebag-browser';

import { INITIAL_STATE } from '../carriers/initialState';
import { buildNoneIntentInitialState } from '../carriers/noneIntent';

import type { CarriersFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/carriers';

export const getCarriersFromUrl = (): CarriersFilterState => {
  if (!GLOBAL.getWindow()?.location) {
    return INITIAL_STATE;
  }
  const queryParams = parseParams();
  const carriersQueryParam = queryParams[CARRIERS];

  if (!carriersQueryParam) {
    return INITIAL_STATE;
  }

  // `airlines=none` is Acorn's CLEAR_ALL emission and means "every carrier
  // explicitly deselected." We can't enumerate carriers at hydration tim
  // (entities arrive with the first Radar response), so we record the intent
  // as a sentinel that anchors `inferDefaultCarrierValue` to `false`; the
  // carriers reducer materialises against it on the first response.
  if (carriersQueryParam.toLowerCase() === 'none') {
    return buildNoneIntentInitialState();
  }

  const parsedCarriersParam = booleanKeyValuesParamParser
    .deserialize(carriersQueryParam)
    .filter(({ key }) => key.trim().length > 0);

  if (parsedCarriersParam.length === 0) {
    return INITIAL_STATE;
  }

  return parsedCarriersParam.reduce<CarriersFilterState>((acc, { key, value }) => {
    acc[key] = { value };
    return acc;
  }, {});
};
